import { Component, computed, input } from '@angular/core';
import { LeadLinkPipe } from '@web/shared/pipes/lead-link.pipe';
import { isEmpty } from 'class-validator';
import { LeadCodeTagComponent } from '../../lead-code-tag.component';
import { SearchLeadEntry } from '../interfaces/search-lead-entry.interface';
import { DetailItem, SearchItemBaseComponent } from './search-item-base.component';
import { SearchStatusChipComponent } from './search-status-chip.component';

@Component({
  selector: 'app-search-lead-item',
  imports: [LeadCodeTagComponent, LeadLinkPipe, SearchItemBaseComponent, SearchStatusChipComponent],
  template: `
    @let _item = item();

    <app-search-item-base
      icon="pi pi-flag"
      color="text-soe-tropical-green"
      [detailRouterLink]="_item | leadLink"
      [detailItems]="detailItems()"
    >
      <ng-template #title>
        <div [innerHTML]="_item.profileName"></div>
      </ng-template>

      <ng-template #codeTag>
        <app-lead-code-tag [lead]="_item" [clickable]="false" />
      </ng-template>

      <ng-template #statusChip>
        @if (_item.statusName) {
          <app-search-status-chip
            [name]="_item.statusName"
            [backgroundColor]="_item.statusColor"
            [textColor]="_item.statusTextColor"
          />
        }
      </ng-template>
    </app-search-item-base>
  `,
})
export class SearchLeadItemComponent {
  readonly item = input.required<SearchLeadEntry>();

  readonly detailItems = computed<DetailItem[]>(() => {
    const item = this.item();

    return [
      {
        icon: 'pi pi-tag',
        content: item.interestName,
        isHtml: true,
      },
      {
        icon: 'pi pi-user',
        content: item.targetName,
        isHtml: true,
      },
    ].filter((v) => !isEmpty(v.content));
  });
}
